import React from "react";
import ModalLayout from "src/components/common/Layout/ModalLayout";

interface OptionalModalProps {
  isOpen: boolean;
  isModal: boolean;
  onCloseModal: () => void;
  fullScreen?: boolean;
}

const OptionalModal: React.FC<OptionalModalProps> = ({
  isModal,
  isOpen,
  children,
  onCloseModal,
  fullScreen,
}) => {
  if (isModal) {
    return (
      <ModalLayout
        isOpen={isOpen}
        onClose={onCloseModal}
        fullScreen={fullScreen}
      >
        {children}
      </ModalLayout>
    );
  }

  return <>{children}</>;
};

export default OptionalModal;
